/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Join_Error_RegistrationInputs */



/**
* | output |
* | --- |
* | "Registration failed. Please try again." |
*
* @param {Auth_Join_Error_RegistrationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_join_error_registration = /** @type {((inputs?: Auth_Join_Error_RegistrationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Join_Error_RegistrationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Registrierung fehlgeschlagen. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Registration failed. Please try again.")
});